import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OroBaseResult } from './domain/OroBaseResult';
import { ConfigService, IConfig } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class OroService {


  config!: IConfig;

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
    
    this.config = this.configService.config;
   }

   private handleError(error: HttpErrorResponse) {

    console.error(
      `Backend returned code ${error.status},` +
      `body was: ${error.error}`);

    console.error(error.message);


    let lvResult = new OroBaseResult();
    lvResult.Success = false;
    lvResult.Message = 'configurator.service: ' + error.message;

    return throwError(<any>lvResult);
  }

  public getHello<HelloResult>(name: string) {

    let lvUrl =  this.config.apiBaseUrl + 'getHello';
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.httpClient.post<HelloResult>(lvUrl, { Name: name }, { headers })
      .pipe(catchError((reason: any) => this.handleError(reason)));
  }

  public initHub<InitHubResult>() {

    let lvUrl = this.config.apiBaseUrl + 'InitHub';
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.httpClient.post<InitHubResult>(lvUrl, {}, { headers })
      .pipe(catchError((reason: any) => this.handleError(reason)));
  }

  public contactUsHub<ContactusResult>(module: string) {

    let lvUrl =  this.config.apiBaseUrl + 'OroContactUs';
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.httpClient.post<ContactusResult>(lvUrl, { Module: module }, { headers })
      .pipe(catchError((reason: any) => this.handleError(reason)));
  }

  public faqHub<FAQResult>(module: string) {

    let lvUrl =  this.config.apiBaseUrl + 'OroFAQ';
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.httpClient.post<FAQResult>(lvUrl, { Module: module }, { headers })
      .pipe(catchError((reason: any) => this.handleError(reason)));
  }

}
